import { DocumentNode, gql } from '@apollo/client';
import { Box, Flex, LinkBox, LinkOverlay, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { FollowButton } from '@/components/FollowButton';
import { OrganizationProfileImage } from '@/components/OrganizationProfileImage';

import { SponsorsList_OrganzationFragment } from './graphql-types/SponsorsList_OrganzationFragment';

const ORGANIZATION_FRAGMENT = gql`
  fragment SponsorsList_OrganzationFragment on Organization {
    _id
    name
    ...OrganizationProfileImage_OrganizationFragment
  }
  ${OrganizationProfileImage.organizationFragment}
`;

export const SponsorsList: React.FC<{
  sponsors: SponsorsList_OrganzationFragment[];
}> & {
  organizationFragment: DocumentNode;
} = (props) => {
  return (
    <>
      {props.sponsors.map((sponsor) => {
        return (
          <Box key={sponsor._id} pt="4">
            <LinkBox w="full">
              <Flex alignItems="center" color="gray.600">
                <OrganizationProfileImage
                  organization={sponsor}
                  h={20}
                  w={20}
                  flexShrink="0"
                />
                <Box flexGrow="1" pl="2" pr="4">
                  <LinkOverlay
                    as={NextLink}
                    href={`/sponsors/${sponsor._id}/overview`}
                  >
                    <Text
                      textStyle="xlBodyStrong"
                      color="gray.700"
                      noOfLines={2}
                    >
                      {sponsor.name}
                    </Text>
                  </LinkOverlay>
                </Box>
                <FollowButton organizationId={sponsor._id} />
              </Flex>
            </LinkBox>
          </Box>
        );
      })}
    </>
  );
};

SponsorsList.organizationFragment = ORGANIZATION_FRAGMENT;
